import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "react-query";
import { api } from "services/api";
import { Template } from "types/Template";
import { axiosError, axiosSuccess, handleRequestError, handleRequestSuccess } from "utils/Request";

type DeleteTemplateProps = {
  template: Template;
}

function deleteTemplate(template: Template) {
  return api.delete(`/templates/${template.id}`).then(axiosSuccess).catch(axiosError);
}

export function useDeleteTemplate() {
  const queryClient = useQueryClient();

  return useMutation(({ template }: DeleteTemplateProps) => deleteTemplate(template), {
    onSuccess: () => {
      handleRequestSuccess('Template excluído com sucesso!');
      queryClient.invalidateQueries('admin-templates');
      queryClient.invalidateQueries('templates');
    },
    onError: (error: AxiosError) => {
      handleRequestError(error, 'Ocorreu um erro ao excluir o template. Por favor, tente novamente!');
    }
  });
}
